import React from "react";

const About = () => {
  return (
    <div className="container about">
      <div className=" about-section">
        <div className="about-container">
          <h1 className="about-heading">
            Who <span className="highlight">We </span> Are ?
          </h1>
          <p className="about-text">
            <span className="highlight">LetsEndorse </span> is a social venture
            and a digital market-network of over 350 powerful social innovations
            from across the globe, over 900 grass-root implementation
            partners/NGOs from across India, responsible corporations, local
            administration and socially-savvy individuals. <br />
            We enable intelligent knowledge harnessing of practicable social
            models, build collaborations for co-creating and scaling solutions
            and foster transparent mobilization of funds/resources for
            accelerated intervention.
          </p>
          <div className="endorsers">
            <div className="powered-by">
              <p className="powered">Powered by</p>
              <img
                className="alpha"
                src="/images/social-alpha.png"
                alt="Powered by Social Alpha"
              />
            </div>
            <div className="tata-trust">
              <p className="tata-text">A</p>
              <img
                className="tata-img"
                src="/images/Tata-Trust.jpg"
                alt="A TATA TRUST INITIATIVE"
              />
              <p className="tata-text">INITIATIVE</p>
            </div>
          </div>
          <button type="button" className="about-button">
            <a href="https://www.letsendorse.com/" className="about-link">
              <span className="about-highlight">
                About LetsEndorse <i className="fas fa-arrow-right" />
              </span>
            </a>
          </button>
        </div>
        <div className="copyright-container">
          <p className="copyright">
            ©2018 LetsEndorse Development Pvt. Ltd. All rights reserved.
          </p>
          <div className="about-socio-handles">
            <a href="https://www.facebook.com/letsendorse">
              <i className="fab fa-facebook-f  about-socio-handle" />
            </a>
            <a href="https://twitter.com/letsendorse">
              <i className="fab fa-twitter about-socio-handle" />
            </a>
            <a href="https://www.linkedin.com/company/letsendorse">
              <i className="fab fa-linkedin-in about-socio-handle" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/Components/LandingPage/About.js